// extracted by mini-css-extract-plugin
export var grid = "_2y-0";
export var span1 = "_2y-2";
export var span10 = "_2y-b";
export var span10L = "_2y-z";
export var span10M = "_2y-n";
export var span10Xl = "_2y-1b";
export var span11 = "_2y-c";
export var span11L = "_2y-10";
export var span11M = "_2y-o";
export var span11Xl = "_2y-1c";
export var span12 = "_2y-d";
export var span12L = "_2y-11";
export var span12M = "_2y-p";
export var span12Xl = "_2y-1d";
export var span1L = "_2y-q";
export var span1M = "_2y-e";
export var span1Xl = "_2y-12";
export var span2 = "_2y-3";
export var span2L = "_2y-r";
export var span2M = "_2y-f";
export var span2Xl = "_2y-13";
export var span3 = "_2y-4";
export var span3L = "_2y-s";
export var span3M = "_2y-g";
export var span3Xl = "_2y-14";
export var span4 = "_2y-5";
export var span4L = "_2y-t";
export var span4M = "_2y-h";
export var span4Xl = "_2y-15";
export var span5 = "_2y-6";
export var span5L = "_2y-u";
export var span5M = "_2y-i";
export var span5Xl = "_2y-16";
export var span6 = "_2y-7";
export var span6L = "_2y-v";
export var span6M = "_2y-j";
export var span6Xl = "_2y-17";
export var span7 = "_2y-8";
export var span7L = "_2y-w";
export var span7M = "_2y-k";
export var span7Xl = "_2y-18";
export var span8 = "_2y-9";
export var span8L = "_2y-x";
export var span8M = "_2y-l";
export var span8Xl = "_2y-19";
export var span9 = "_2y-a";
export var span9L = "_2y-y";
export var span9M = "_2y-m";
export var span9Xl = "_2y-1a";
export var stretch = "_2y-1";